<div class="py-4 container-fluid compensation-summary-dashboard-page">
  <div class="compensation-summary-dashboard-heading">
    <div>
      <h4 class="mb-1 compensation-summary-dashboard-title">
        Dashboard Summary
      </h4>
    </div>

    <div class="compensation-summary-dashboard-toolbar" [formGroup]="form">
      <div class="compensation-summary-dashboard-filter">
        <app-select
          label="เทอมการศึกษา"
          formControlName="academicTerm"
          [options]="academicTermOptions"
          [searchable]="false"
          [clearable]="false"
          inputClass="compensation-summary-dashboard-select"
          classes="mb-0"
        ></app-select>
      </div>

      <div class="compensation-summary-dashboard-filter">
        <app-select
          label="ปีการศึกษา"
          formControlName="year"
          [options]="yearOptions"
          [searchable]="false"
          [clearable]="false"
          inputClass="compensation-summary-dashboard-select"
          classes="mb-0"
        ></app-select>
      </div>
    </div>
  </div>

  <div class="compensation-summary-dashboard-state" *ngIf="isLoading()">
    กำลังโหลด Dashboard Summary ค่าสอนชดเชย...
  </div>

  <div
    class="compensation-summary-dashboard-state compensation-summary-dashboard-state-error"
    *ngIf="!isLoading() && hasLoadError()"
  >
    ไม่สามารถโหลดข้อมูล Summary ค่าสอนชดเชยได้ กรุณาลองใหม่อีกครั้ง
  </div>

  <section class="compensation-summary-dashboard-card compensation-summary-dashboard-user-summary" aria-label="current user summary">
    <div class="compensation-summary-dashboard-user-profile">
      <h5>{{ currentUserName }}</h5>

      <dl class="compensation-summary-dashboard-user-details">
        <div>
          <dt>อีเมล</dt>
          <dd>{{ currentUserEmail }}</dd>
        </div>

        <div>
          <dt>ตำแหน่ง</dt>
          <dd>{{ currentUserPosition }}</dd>
        </div>

        <div>
          <dt>ตำแหน่งทางวิชาการ</dt>
          <dd>{{ currentUserAcademicRank }}</dd>
        </div>

        <div class="compensation-summary-dashboard-user-departments">
          <dt>สาขาวิชา</dt>
          <dd>
            <span
              class="compensation-summary-dashboard-department-chip"
              *ngFor="let department of currentUserDepartments"
            >
              {{ department }}
            </span>
          </dd>
        </div>
      </dl>
    </div>

    <div class="compensation-summary-dashboard-term-summary">
      <strong>เทอมการศึกษา {{ academicTermLabel }}</strong>
      <span>ปีการศึกษา {{ academicYearLabel }}</span>
    </div>
  </section>

  <section class="compensation-summary-dashboard-kpis" aria-label="request metrics">
    <div
      class="compensation-summary-dashboard-card compensation-summary-dashboard-kpi"
      *ngFor="let metric of requestMetrics"
      [ngClass]="getMetricClass(metric)"
    >
      <span class="compensation-summary-dashboard-kpi-icon" aria-hidden="true">
        <i class="bi" [ngClass]="metric.icon"></i>
      </span>

      <span class="compensation-summary-dashboard-kpi-copy">
        <span>{{ metric.label }}</span>
        <strong>
          {{ metric.value }}
          <small *ngIf="metric.unit">{{ metric.unit }}</small>
        </strong>
      </span>
    </div>
  </section>

  <section
    class="compensation-summary-dashboard-card compensation-summary-dashboard-compensation"
    aria-labelledby="compensation-summary-dashboard-compensation-title"
  >
    <div class="compensation-summary-dashboard-compensation-header">
      <div>
        <h5 id="compensation-summary-dashboard-compensation-title">สรุปค่าสอนเกินภาระงาน</h5>
        <p>ภาพรวมค่าตอบแทนเทอมการศึกษา {{ academicTermLabel }}</p>
      </div>

      <div class="compensation-summary-dashboard-total">
        <span>ค่าตอบแทนรวม</span>
        <strong>{{ formatCurrency(totalCompensationAmount) }} บาท</strong>
      </div>
    </div>

    <div class="compensation-summary-dashboard-program-grid">
      <article class="compensation-summary-dashboard-program-card">
        <div class="compensation-summary-dashboard-program-header">
          <div class="compensation-summary-dashboard-program-title">
            <span class="compensation-summary-dashboard-program-icon" aria-hidden="true">
              <i class="bi bi-book"></i>
            </span>
            <h6>หลักสูตรปกติ</h6>
          </div>

          <div class="compensation-summary-dashboard-program-actions">
            <button
              type="button"
              class="btn btn-link p-0 text-decoration-underline compensation-summary-dashboard-announcement-link"
              aria-label="ดูประกาศหลักสูตรปกติ"
              aria-haspopup="dialog"
              [disabled]="announcementLoading()"
              (click)="onOpenAnnouncementPreview('regular')"
            >
              ดูประกาศ
            </button>
            <span
              class="compensation-summary-dashboard-status"
              [ngClass]="regularStatusClass"
            >
              <i class="bi" [ngClass]="regularStatusIcon" aria-hidden="true"></i>
              {{ regularStatusLabel }}
            </span>
          </div>
        </div>

        <div class="compensation-summary-dashboard-program-amount">
          <span>ค่าตอบแทน</span>
          <strong [class.compensation-summary-dashboard-positive]="regularCompensationAmount > 0">
            {{ formatCurrency(regularCompensationAmount) }} บาท
          </strong>
        </div>

        <div class="compensation-summary-dashboard-workload">
          <p>
            <span>ภาระงานรวม</span>
            <strong>
              {{ formatPlainNumber(regularTotalWorkload) }} / {{ formatPlainNumber(regularMinimumWorkload) }} ชม.
            </strong>
          </p>
          <div
            class="compensation-summary-dashboard-progress"
            role="progressbar"
            aria-label="สัดส่วนภาระงานรวมของหลักสูตรปกติ"
            aria-valuemin="0"
            [attr.aria-valuemax]="regularMinimumWorkload"
            [attr.aria-valuenow]="regularTotalWorkload"
          >
            <span
              class="compensation-summary-dashboard-progress-primary"
              [style.width.%]="regularBaseProgressPercent"
            ></span>
            <span
              class="compensation-summary-dashboard-progress-success"
              [style.width.%]="regularExcessProgressPercent"
            ></span>
          </div>
        </div>

        <dl class="compensation-summary-dashboard-program-metrics">
          <div>
            <dt>ชั่วโมงเบิกได้</dt>
            <dd>{{ formatPlainNumber(regularPayableHours) }} ชม.</dd>
          </div>
          <div>
            <dt>ปริญญาตรี</dt>
            <dd [class.compensation-summary-dashboard-positive]="undergraduateCompensationAmount > 0">
              {{ formatCurrency(undergraduateCompensationAmount) }} บาท
            </dd>
          </div>
          <div>
            <dt>ปริญญาโท–เอก</dt>
            <dd [class.compensation-summary-dashboard-positive]="graduateCompensationAmount > 0">
              {{ formatCurrency(graduateCompensationAmount) }} บาท
            </dd>
          </div>
        </dl>

        <ng-container
          *ngTemplateOutlet="calculationMethodTemplate; context: { $implicit: calculationMethods.regular, id: 'regular' }"
        ></ng-container>
      </article>

      <article class="compensation-summary-dashboard-program-card">
        <div class="compensation-summary-dashboard-program-header">
          <div class="compensation-summary-dashboard-program-title">
            <span class="compensation-summary-dashboard-program-icon" aria-hidden="true">
              <i class="bi bi-globe2"></i>
            </span>
            <h6>หลักสูตรนานาชาติ</h6>
          </div>

          <div class="compensation-summary-dashboard-program-actions">
            <button
              type="button"
              class="btn btn-link p-0 text-decoration-underline compensation-summary-dashboard-announcement-link"
              aria-label="ดูประกาศหลักสูตรนานาชาติ"
              aria-haspopup="dialog"
              [disabled]="announcementLoading()"
              (click)="onOpenAnnouncementPreview('international')"
            >
              ดูประกาศ
            </button>
            <span
              class="compensation-summary-dashboard-status"
              [ngClass]="internationalStatusClass"
            >
              <i class="bi" [ngClass]="internationalStatusIcon" aria-hidden="true"></i>
              {{ internationalStatusLabel }}
            </span>
          </div>
        </div>

        <div class="compensation-summary-dashboard-program-amount">
          <span>ค่าตอบแทน</span>
          <strong [class.compensation-summary-dashboard-positive]="internationalCompensationAmount > 0">
            {{ formatCurrency(internationalCompensationAmount) }} บาท
          </strong>
        </div>

        <div class="compensation-summary-dashboard-workload">
          <p>
            <span>ภาระงานรายสัปดาห์</span>
            <strong>
              {{ formatPlainNumber(internationalWeeklyWorkload) }} / {{ formatPlainNumber(internationalMinimumWeeklyWorkload) }} ชม.
            </strong>
          </p>
          <div
            class="compensation-summary-dashboard-progress"
            role="progressbar"
            aria-label="สัดส่วนภาระงานรายสัปดาห์ของหลักสูตรนานาชาติ"
            aria-valuemin="0"
            [attr.aria-valuemax]="internationalMinimumWeeklyWorkload"
            [attr.aria-valuenow]="internationalWeeklyWorkload"
          >
            <span
              class="compensation-summary-dashboard-progress-primary"
              [style.width.%]="internationalProgressPercent"
            ></span>
          </div>
        </div>

        <dl class="compensation-summary-dashboard-program-metrics">
          <div>
            <dt>ภาระงานรายสัปดาห์</dt>
            <dd>{{ formatPlainNumber(internationalWeeklyWorkload) }} ชม.</dd>
          </div>
          <div>
            <dt>ส่วนขาด</dt>
            <dd>{{ formatPlainNumber(internationalWorkloadShortfall) }} ชม.</dd>
          </div>
          <!-- <div>
            <dt>สัดส่วนเบิกได้</dt>
            <dd>{{ formatPlainNumber(internationalPayablePercentage) }}%</dd>
          </div> -->
        </dl>

        <ng-container
          *ngTemplateOutlet="calculationMethodTemplate; context: { $implicit: calculationMethods.international, id: 'international' }"
        ></ng-container>
      </article>
    </div>
  </section>
</div>

<ng-template #calculationMethodTemplate let-method let-id="id">
  <section
    class="compensation-summary-dashboard-method"
    [attr.aria-labelledby]="'compensation-summary-dashboard-' + id + '-method-title'"
  >
    <h6 [id]="'compensation-summary-dashboard-' + id + '-method-title'">
      <i class="bi bi-calculator" aria-hidden="true"></i>
      คำอธิบายวิธีการคำนวณภาระงาน
    </h6>
    <p>{{ method.summary }}</p>
    <ol *ngIf="method.groups.length > 0">
      <li *ngFor="let group of method.groups">
        {{ group.title }}
        <ul>
          <li *ngFor="let item of group.items">{{ item }}</li>
        </ul>
      </li>
    </ol>
    <p class="compensation-summary-dashboard-method-note" *ngIf="method.note">
      <strong>หมายเหตุ :</strong> {{ method.note }}
    </p>
  </section>
</ng-template>

<div
  class="compensation-summary-dashboard-pdf-modal-overlay"
  *ngIf="isAnnouncementModalOpen()"
  role="dialog"
  aria-modal="true"
  aria-labelledby="compensation-summary-dashboard-pdf-modal-title"
>
  <div class="compensation-summary-dashboard-pdf-modal-panel">
    <div class="compensation-summary-dashboard-pdf-modal-header">
      <h5 id="compensation-summary-dashboard-pdf-modal-title">
        {{ announcementPreviewTitle() }}
      </h5>
      <button
        type="button"
        class="btn-close"
        aria-label="ปิดตัวอย่างประกาศ"
        (click)="onCloseAnnouncementPreview()"
      ></button>
    </div>

    <div class="compensation-summary-dashboard-pdf-modal-body">
      <div class="compensation-summary-dashboard-pdf-state" *ngIf="announcementLoading()">
        กำลังโหลด PDF...
      </div>
      <div
        class="compensation-summary-dashboard-pdf-state compensation-summary-dashboard-pdf-state-error"
        *ngIf="!announcementLoading() && announcementError()"
      >
        ไม่สามารถโหลด PDF ได้ กรุณาลองใหม่อีกครั้ง
      </div>
      <iframe
        *ngIf="!announcementLoading() && !announcementError() && announcementPreviewUrl() as previewUrl"
        class="compensation-summary-dashboard-pdf-preview"
        [src]="previewUrl"
        [attr.title]="announcementPreviewTitle()"
      ></iframe>
    </div>

    <div class="compensation-summary-dashboard-pdf-modal-footer">
      <button type="button" class="btn btn-light" (click)="onCloseAnnouncementPreview()">
        ปิด
      </button>
    </div>
  </div>
</div>
